@if (!editMode) {
  <h1 mat-dialog-title>Opret fast pris aftale</h1>
}
@if (editMode) {
  <h1 mat-dialog-title>Ændre fast pris aftale</h1>
}
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline">
        @if (isPrivatKunde) {
          <mat-label>Fast pris (årlig) inkl. moms</mat-label>
        }
        @if (!isPrivatKunde) {
          <mat-label>Fast pris (årlig) ekskl. moms</mat-label>
        }
        <input type="number" formControlName="fastPris" matInput />
      </mat-form-field>
    </div>
    <div class="form-row flex">
      <div class="form-row form-row--inline">
        <mat-form-field appearance="outline">
          <mat-label>Fast pris start</mat-label>
          <mat-datepicker-toggle matPrefix [for]="fixedPriceStartDatePicker"></mat-datepicker-toggle>
          <input
            #fixedPriceStartDateInput
            matInput
            [matDatepicker]="fixedPriceStartDatePicker"
            formControlName="fixedPriceStartDate"
            [min]="tomorrow"
            />
            <mat-datepicker #fixedPriceStartDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="form-row form-row--inline">
          <mat-form-field appearance="outline">
            <mat-label>Fast pris udløb</mat-label>
            <mat-datepicker-toggle matPrefix [for]="fixedPriceEndDatePicker"></mat-datepicker-toggle>
            <input
              #fixedPriceEndDateInput
              matInput
              [matDatepicker]="fixedPriceEndDatePicker"
              formControlName="fixedPriceEndDate"
              [min]="minEndDate"
              />
              <mat-datepicker #fixedPriceEndDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
    <div mat-dialog-actions class="row-reverse">
      @if (!editMode) {
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Tilføj</button>
      }
      @if (editMode) {
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Gem</button>
      }
      <button (click)="cancel()" class="modal-cancel" mat-raised-button>Fortryd</button>
    </div>
